
import * as ModulesNamespace from './modules';

export const imports = [
  ModulesNamespace.AngularMaterialModule,
];